import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { IoIosCheckmark } from "react-icons/io";

const CustomCheckbox = ({
  checked,
  onCheckedChange,
  label,
  onUnchecked,
  onChecked,
}) => {
  const handleChange = (newCheckedState) => {
    onCheckedChange(newCheckedState);

    if (newCheckedState && onChecked) {
      onChecked();
    } else if (!newCheckedState && onUnchecked) {
      onUnchecked();
    }
  };

  return (
    <label className="custom-checkbox-container">
      <CheckboxPrimitive.Root
        className="custom-checkbox"
        checked={checked}
        onCheckedChange={handleChange}
      >
        <CheckboxPrimitive.Indicator>
          <IoIosCheckmark className="custom-checkbox-icon" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {label && <span className="custom-checkbox-label">{label}</span>}
    </label>
  );
};

export default CustomCheckbox;
